import { combineReducers } from 'redux';
import agentReducer from './agentReducer';
import consumerReducer from './consumerReducer';

export default combineReducers({
  agents: agentReducer,
  consumer: consumerReducer,
})